import { render } from "./PairInput.vue?vue&type=template&id=519d0c96&scoped=true"
import script from "./PairInput.vue?vue&type=script&lang=js"
export * from "./PairInput.vue?vue&type=script&lang=js"

import "./PairInput.vue?vue&type=style&index=0&id=519d0c96&scoped=true&lang=scss"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519d0c96"]])

export default __exports__